import { clientId, lpRequest } from '../../../../core/api/lp-request';

/**
 * Client settings in cb's `GET /settings` shape. The lists are top-level client fields, as cb read them; the rest live
 * under `settings` in the backend's answer. Only `vehicle_types` is shown today, so the others default rather than fail.
 */
export const getOrganisationSettings = async (): Promise<any> => {
  const client = await lpRequest(`/client/${clientId()}`);
  const settings = client.settings || {};

  return {
    scan: settings.scan,
    cluster: settings.cluster || { lock: {} },
    pooling: settings.pooling || {},
    ratings: client.ratings || [],
    abandonment_reasons: client.abandonment_reasons || [],
    sms_enabled: settings.sms_enabled,
    vehicle_types: client.vehicle_types || []
  };
};
